import { Button } from '@chakra-ui/react';
import { MapContainer, TileLayer, Marker, useMap, Popup } from 'react-leaflet';
import { Organization } from '../../../types';

const ZoomToMarker = ({ position }: { position: [number, number] }) => {
  const map = useMap();

  const onClick = () => {
    map.flyTo(position, 16, { animate: true });
  };

  const panToUS = () => {
    map.flyTo([39.8283, -98.5795], 4, { animate: true });
  };

  return <Marker position={position}>
      <Popup>
        <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-around', gap: 8, alignItems: 'center'}}>
          <Button onClick={onClick}>
            Zoom to location
          </Button>
          <Button onClick={panToUS}>
            Pan out to U.S.
          </Button>
        </div>
      </Popup>
    </Marker>;
};

const MapContainerComponent = ({ position }: { position: [number, number], data?: Organization[]}) => {

  return (
    <MapContainer
      center={position}
      zoom={13}
      scrollWheelZoom={true}
      style={{ height: '100%', width: '100%' }}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {position &&  (
        <ZoomToMarker position={position} />
      )}
    </MapContainer>
  );
};

export default MapContainerComponent;